import { View } from './view'

export const BurgerV2 = View
